import React, { Component } from 'react';
import { fetchData } from 'Common/utils.js';
import SGDropDown from 'Common/SGDropDown/SGDropDownEx.js';
import axios from 'axios';
import './LoginStyle.css';
import _ from 'lodash';


export default class LogInWizard extends Component {


    constructor(props) {
        super(props);
        
        this.state =
        {
            LicBranchListDet: [],
            CurrLocation: 1,
            CurrBranchCounter:1,
            isCustomBroker: true,
            CBType: '',
            CBPANNo:'',
            CBName:'',
            CBNamedisable:false,
            CBPANdisable:false,
            CBIECNo:'',
            BranchState: '',
            StateList: [],
            CityList: [],
            BranchCity: '',
            CountryList: [],
            BranchCountry: '',
            CompanyID: 0,
            LocationID: 0,
            UserID: 0,
            LicBranchName:'',
            LicBranchCode:'',
            LicBranchAddreess: '',
            LicBranchCountry: '',
            LicBranchCountryName: '',
            LicBranchState: '',
            LicBranchStateCode: '',
            LicBranchCity: '',
            LicPostalCode: '',
            LicCBLicNo: '',
            LicCBAddreess: '',
            disableCloseBranch: true,
            disableNextBranch: true,
            disableUpdateBranch: false,
            disableNextSaveBtn:true,
            ShowConfirmSave: false,
            ShowConfirmCloseWizard: false,
            IsBillCompSameAsComp: false,
            PrevCBPANNo:'',
            PrevCBName:''
           

           
        }
    }

    componentWillMount() {
        
        this.FillStateList();
        this.initDetails(this.props);
    }


    UNSAFE_componentWillReceiveProps(newProps) {
        if (!_.isEqual(newProps, this.props))
            this.initDetails(newProps);
    }


   
    initDetails(newProps) {
        this.setState({ CBLicType: newProps.CustomBrokerDet[0].CHALicType, CBCompType: newProps.CustomBrokerDet[0].CHACompanyType });


        if (newProps.CustomBrokerDet[0].CHALicType == "OWNED") {
            this.setState({ CBNamedisable: true, CBName: newProps.CustomBrokerDet[0].CHAName, IsBillCompSameAsComp: newProps.CustomBrokerDet[0].IsBillCompSameAsComp });


            if (newProps.CustomBrokerDet[0].IsBillCompSameAsComp) {
                this.setState({ CBPANNo: newProps.CustomBrokerDet[0].CHAPAN });
                if (newProps.CustomBrokerDet[0].CHAPAN.length > 0)
                    this.setState({ CBPANdisable: true });
            }

        }

        else {
            this.setState({
                PrevCBPANNo: newProps.CustomBrokerDet[0].CHAPAN, PrevCBName: newProps.CustomBrokerDet[0].CHAName,
                IsBillCompSameAsComp: newProps.CustomBrokerDet[0].IsBillCompSameAsComp
            });
        }

        if (newProps.CustomBrokerDet[0].CHACompanyType == "Self") {
            this.setState({ CBNamedisable: true, CBName: newProps.CustomBrokerDet[0].CHAName, IsBillCompSameAsComp: newProps.CustomBrokerDet[0].IsBillCompSameAsComp });

            this.setState({ isCustomBroker: false });
            if (newProps.CustomBrokerDet[0].IsBillCompSameAsComp) {
                this.setState({ CBPANNo: newProps.CustomBrokerDet[0].CHAPAN });
                if (newProps.CustomBrokerDet[0].CHAPAN.length > 0)
                    this.setState({ CBPANdisable: true });
            }

        }



        if (newProps.CustomBrokerDet[0].SelClearIEC.length > 0)
            this.setState({ CBIECNo: newProps.CustomBrokerDet[0].SelClearIEC });
    }

    onBranchCityChange(e) {
        this.setState({ LicBranchCity: e.target.value });
    }

    onBranchStateChange(e) {
        this.setState({ LicBranchStateCode: e.value, LicBranchState: e.label });
    }

    onCBNameChange(e) {
        this.setState({ CBName: e.target.value });
    }

    SetCBLicType(e) {
        this.setState({ CBLicType: e.target.value });
        if(e.target.value=="LEASED")
        {
            this.setState({PrevCBPANNo:this.state.CBPANNo,PrevCBName:this.state.CBName});
            this.setState({CBPANNo:"",CBName:"",CBNamedisable:false,CBPANdisable:false});
        }
        else
        {
            this.setState({CBName:this.state.PrevCBName,CBNamedisable:true});
            if(this.state.IsBillCompSameAsComp && this.state.PrevCBPANNo.length > 0)
            {
                this.setState({CBPANNo:this.state.PrevCBPANNo,CBPANdisable:true});
            }
            else
                this.setState({CBPANNo:""});
   
        }


    }

    onCBPANChange(e) {
        this.setState({ CBPANNo: e.target.value });
    }

    onLicCBNoChnage(e) {
        this.setState({ LicCBLicNo: e.target.value });
    }

    onLicBranchNameChnage(e) {
        this.setState({ LicBranchName: e.target.value });
    }
    onLicBranchCodeChnage(e) {
        this.setState({ LicBranchCode: e.target.value });
    }
    onLicBranchAddreessChnage(e) {
        this.setState({ LicBranchAddreess: e.target.value });
    }
    onLicPostalCodeChnage(e) {
        this.setState({ LicPostalCode: e.target.value });
    }
    onLicCBLicNoChnage(e) {
        this.setState({ LicCBLicNo: e.target.value });
    }
    onLicCBAddreessChnage(e) {
        this.setState({ LicCBAddreess: e.target.value });
    }


    onCBIECChange(e) {
        this.setState({ CBIECNo: e.target.value });
    }

     showBranchDet() {
         document.getElementById('dvBranchDtl').style.display = "block";
         document.getElementById('dvCBDet').style.display = "none";
         var BranchDtl = {};
         if (this.state.LicBranchListDet && this.state.LicBranchListDet != []) {
             var BranchDtl = this.state.LicBranchListDet[this.state.CurrLocation - 1];
             if (BranchDtl) {
                 this.setState({
                     LicBranchName: BranchDtl["BranchName"], LicBranchCode: BranchDtl["BranchCode"], LicBranchAddreess: BranchDtl["BranchAddress"],
                     LicBranchCountry: BranchDtl["BranchCountry"], LicBranchCountryName: BranchDtl["BranchCountryName"], LicBranchState: BranchDtl["BranchState"],
                     LicBranchStateCode: BranchDtl["BranchStateCode"], LicBranchCity: BranchDtl["BranchCity"],
                     LicPostalCode: BranchDtl["BranchPostalCode"], LicCBLicNo: BranchDtl["CBLiceneNo"], LicCBAddreess: BranchDtl["CBAddress"]

                 });
             }
             else
                 alert("Branch details not available");
         }
         else
             alert("Company's Branch list not available.");
         
         
    }

    onCloseConfirmBox() {
        this.setState({ ShowConfirmSave: false });
    }

    onConfirmCloseWizard() {
        this.setState({ ShowConfirmCloseWizard: false });
        
    }


    ValidateLicBranchDet() {
        var strError = '';
        if (this.state.LicBranchName.length <= 0)
            strError += "Please enter branch name.\n";

        if (this.state.LicBranchAddreess.length <= 0)
            strError += "Please enter address of branch.\n";

        if (this.state.LicBranchCountry.length <= 0)
            strError += "Please enter country of branch.\n";

        if (this.state.LicBranchStateCode.length <= 0)
            strError += "Please select state of branch.\n";


        if ( this.state.isCustomBroker && this.state.LicCBLicNo.length <= 0)
            strError += "Please enter CB license No.";

        var CurrBranchID = this.state.LicBranchListDet[this.state.CurrLocation - 1]["BranchID"];
        var BranchList = this.state.LicBranchListDet.filter(({ BranchID }) => BranchID != CurrBranchID);
        if (this.state.LicBranchName.length > 0) {
            var result = BranchList.filter(({ BranchName }) => BranchName == this.state.LicBranchName.trim());
            if (result.length > 0)
                strError += "A branch with this name already exists, please enter another name.\n";
        }
        if (this.state.LicBranchCode.length > 0) {
            var result = BranchList.filter(({ BranchCode }) => BranchCode == this.state.LicBranchCode.trim());
            if (result.length > 0)
                strError += "A branch with this code already exists, please enter another code.\n";
        }
        if (this.state.LicCBLicNo.length > 0) {
            var result = BranchList.filter(({ CBLiceneNo }) => CBLiceneNo == this.state.LicCBLicNo.trim());
            if (result.length > 0)
                strError += "A branch with this CB licence No already exists, please enter another CB licence No.\n";
        }


        if (strError.length > 0) {
            alert(strError);
            return;
        }
        else {
           
            this.setState({ ShowConfirmSave: true });
                return;


        }
    }

    UpdateDetails() {
        this.onCloseConfirmBox();
        if (document.getElementById('dvBranchDtl').style.display == "block")
            this.UpdateBranchDtl()
        else
            this.OnSaveClick();
        
    }

    UpdateBranchDtl() {

        var BranchDtl = {};
        var BranchDtl = this.state.LicBranchListDet[this.state.CurrLocation - 1];
        BranchDtl["BranchName"] = this.state.LicBranchName;
        BranchDtl["BranchCode"] = this.state.LicBranchCode;
        BranchDtl["BranchAddress"] = this.state.LicBranchAddreess;
        BranchDtl["BranchCountry"] = this.state.LicBranchCountry;
        BranchDtl["BranchCountryName"] = this.state.LicBranchCountryName;
        BranchDtl["BranchState"] = this.state.LicBranchState;
        BranchDtl["BranchStateCode"] = this.state.LicBranchStateCode;
        BranchDtl["BranchCity"] = this.state.LicBranchCity;
        BranchDtl["BranchPostalCode"] = this.state.LicPostalCode;
        BranchDtl["CBLiceneNo"] = this.state.LicCBLicNo;
        BranchDtl["CBAddress"] = this.state.LicCBAddreess;

        this.state.LicBranchListDet.splice(this.state.CurrLocation - 1, BranchDtl);
        this.setState({ disableUpdateBranch: true, disableNextBranch: false, disableCloseBranch: false });


    }
    validateSession() {
        alert('This form is no longer valid.Please reopen again.\nClick Ok to close this form');
       this.onKillCurrentClick();
    }
    onKillCurrentClick() {
        window.location = window.baseUrl + 'Login/KillCurrentUserSession';
    }
    SaveBranchDetails() {
        this.onConfirmCloseWizard();
        var webMethodUrl = 'Core/Login/WebService/LoginHelper.asmx/UpdateLicBranchData';
        var htParams = {};
        htParams['LicBranchListDet'] = JSON.stringify(this.state.LicBranchListDet);
        htParams['LICompanyID'] = this.props.CustomBrokerDet[0].LICompanyID;
        axios({
            url: webMethodUrl,
            method: "POST",
            data: JSON.stringify({ paramObj: JSON.stringify(htParams) }),
            headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        })
            .then(resp => {
                var data = resp.data;
                if (data != null && String(data.d).length > 0) {

                    if (data.d == true)
                        this.onKillCurrentClick();
                    else {
                        this.validateSession();
                    }
                }
            });
    }

    CloseWizard() {

        this.setState({ ShowConfirmCloseWizard: true });
        
    }

    NextBranch() {
        if (this.state.CurrLocation == this.state.LicBranchListDet.length) {
            alert("You have created all the branches as per number of branch permitted in the license");
            return;
        }
        this.setState({ CurrLocation: this.state.CurrLocation + 1 }, () => { this.showBranchDet() })
        this.setState({ disableUpdateBranch: false, disableNextBranch: true, disableCloseBranch: false });
    }

    FillStateList() {
        fetchData({ fvk: window.FormKey }, 'Core/Login/WebService/LoginHelper.asmx/GetStateList',
            (data) => { this.setState({ StateList: data }) });
    }

    OnNextClick() {
        
        var webMethodUrl = 'Core/Login/WebService/LoginHelper.asmx/GetLicBranchData';
        var htParams = {};
        htParams['LICompanyID'] = this.props.CustomBrokerDet[0].LICompanyID;
        axios({
            url: webMethodUrl,
            method: "POST",
            data: JSON.stringify({ paramObj: JSON.stringify(htParams) }),
            headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        })
            .then(resp => {
                var data = resp.data;
                if (data != null && String(data.d).length > 0) {
                    if (data.d == false) {
                        this.validateSession();
                    }
                    else {
                    var LicBranchDet = JSON.parse(data.d);
                        if (LicBranchDet != null) {
                            this.setState({ LicBranchListDet: LicBranchDet }, () => { this.showBranchDet(); });
                        }
                    }
                }
            });


    }

    ValidateCBDet() {
        var strError = "";

        if (this.state.CBCompType == "Self" && this.state.CBIECNo.length <= 0)
            strError += "Please Enter IEC No.\n";

        if (this.state.CBPANNo.length <= 0)
            strError += "Please Enter PAN No.\n";

        if (this.state.CBName.length <= 0)
            strError += "Please Enter Name.\n";

       

        if (strError.length > 0) {
            alert(strError);

            return;
        }
        else {
           
            this.setState({ ShowConfirmSave: true });
            return;
        }
    }

    

    OnSaveClick() {
        var webMethodUrl = 'Core/Login/WebService/LoginHelper.asmx/UpdateCustomBrokerInfo';
        var htParams = {};
        htParams['CBIECCode'] = this.state.CBIECNo;
        htParams['CBName'] = this.state.CBName;
        htParams['CBLicType'] = this.state.CBLicType;
        htParams['CBCompType'] = this.state.CBCompType;
        htParams['CBPANNo'] = this.state.CBPANNo;
        htParams['LICompanyID'] = this.props.CustomBrokerDet[0].LICompanyID;
       

        axios({
            url: webMethodUrl,
            method: "POST",
            data: JSON.stringify({ paramObj: JSON.stringify(htParams) }),
            headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        })
            .then(resp => {
                var data = resp.data;
                if (data != null && String(data.d).length > 0) {
                    if (data.d == false) {
                        this.validateSession();
                    }
                    else {
                        var CBInfo = JSON.parse(data.d);
                        if (CBInfo != null) {
                            console.log('saved successfully');
                            this.setState({ disableNextSaveBtn: false });

                        }
                    }
                }
            });
        
       
    }

   
    render() {
        try {
            return this.GetWizardFormUI();
        }
        catch (ee) {
            console.log("GetWizardFormUI(): Error in Wizard Form: ", ee);
            throw new Error('Wizard Form crashed!');
        }
       

    }

    GetWizardFormUI() {
        let updateHeader;
        if (this.state.isCustomBroker) {
            updateHeader = <h2 style={{ color: "#25bef6" }}>Update Custom Broker Info</h2>
        }
        else {
            updateHeader = <h2 style={{ color: "#25bef6" }}>Update IEC Info</h2>;
        }
        return (

            <div>
                <div>
                    <div id="dvConfirm"  className="WizardConfirmBGstyle" style={{ display: (this.state.ShowConfirmSave) ? "" : "none" }}>
                            <div className="WizardConfirmPanel" style={{ display: (this.state.ShowConfirmSave) ? "" : "none" }}>
                                <table style={{ margin: "5px", height: '100px' }} cellPadding="2">
                                    <tr>
                                        <td style={{ textAlign: 'center' }}>
                                            <span style={{ fontSize: "15px" }}>Please confirm as details can’t be changed once saved</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ paddingLeft: "50px", paddingRight: "50px" }}>
                                            <input id='BtnProceed' type="button" className="formWizardConfirm-bu"
                                                value="Proceed to save" onClick={() => this.UpdateDetails()} autoFocus />
                                            <input style={{ marginLeft: "20px" }} id='BtnCancel' type="button" className="formWizardConfirm-bu"
                                                value="Let me review" onClick={() => this.onCloseConfirmBox()} />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                    </div>
                    <div id="dvBranchConfirm" className="WizardConfirmBGstyle" style={{ display: (this.state.ShowConfirmCloseWizard) ? "" : "none" }}>
                    <div className="WizardConfirmPanel" style={{ display: (this.state.ShowConfirmCloseWizard) ? "" : "none" }}>
                            <table style={{ margin: "5px", height: '100px' }} cellPadding="2">
                            <tr>
                                <td style={{ textAlign: 'center' }}>
                                    <span style={{ fontSize: "15px" }}>Do you want to close this form ?</span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ paddingLeft: "50px", paddingRight: "50px" }}>
                                    <input id='BtnProceed' type="button"  className="formWizardConfirm-bu"
                                        value="Yes" onClick={() => this.SaveBranchDetails()} autoFocus/>
                                    <input style={{ marginLeft: "20px" }} id='BtnCancel' type="button" className="formWizardConfirm-bu"
                                        value="No" onClick={() => this.onConfirmCloseWizard()} />
                                </td>
                            </tr>
                        </table>
                        </div>
                    </div>
                    <div id="dvCBDet" className="WizardCBPanel">

                        <table className="my-special-table" style={{ marginLeft: "auto", marginRight: "auto", borderSpacing: "0px 0.5em" }}>
                            <tr>
                                <th colSpan="2">
                                    {updateHeader}
                                </th>

                            </tr>
                            <tr style={{ display: this.state.isCustomBroker ? '' : 'none' }}>
                                <td>
                                    <span className="WizardSpan required">CB Licence owned by</span>
                                </td>
                            </tr>
                            <tr style={{ display: this.state.isCustomBroker ? '' : 'none' }}>
                                <td>
                                    <select type="select" className="userid2" style={{ width: "350px" }} value={this.state.CBLicType} tabIndex="1"
                                        onChange={(e) => this.SetCBLicType(e)}>
                                        <option value="OWNED">Self-owned</option>
                                        <option value="LEASED">Other</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span className="WizardSpan required">Name</span>
                                </td>

                            </tr>
                            <tr>
                                <td>
                                    <input id="" ref="txtCBName" type='text' className='userid1' style={{ width: "350px" }}
                                        value={this.state.CBName} onChange={(e) => this.onCBNameChange(e)} disabled={this.state.CBNamedisable}
                                        placeholder={this.state.isCustomBroker ? "Enter Custom Broker Name" : "Enter Name as per IEC"} tabIndex="2" />
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <span className="WizardSpan required">PAN</span>
                                </td>

                            </tr>
                            <tr>
                                <td>
                                    <input id="txtCBPANNo" ref="txtUserId" type='text' className='userid1' maxlength="10"
                                        value={this.state.CBPANNo} onChange={(e) => this.onCBPANChange(e)} disabled={this.state.CBPANdisable}
                                        placeholder={this.state.isCustomBroker ? "Enter PAN Based CB License No." : "Enter PAN"} tabIndex="3" />
                                </td>
                            </tr>
                            <tr style={{ display: this.state.isCustomBroker ? 'none' : '' }}>
                                <td>
                                    <span className="WizardSpan required">IEC</span>
                                </td>

                            </tr>
                            <tr style={{ display: this.state.isCustomBroker ? 'none' : '' }}>
                                <td>
                                    <input id="txtIECCOde" ref="txtUserId" type='text' className='userid1'
                                        value={this.state.CBIECNo} onChange={(e) => this.onCBIECChange(e)}
                                        placeholder="Enter IEC No." tabIndex="4" maxlength="10" />
                                </td>
                            </tr>
                            <tr align="center">
                                <td>
                                    <table>
                                        <tr>
                                            <td style={{ display: (!this.state.disableNextSaveBtn)?"none":"" }}>
                                                <input id='BtnSave' type="button" style={{ textAlign: "center" }} className={this.state.disableNextSaveBtn ? "formWizard-bu" : "form1-bu-d"}
                                                    disabled={!this.state.disableNextSaveBtn} value="Save" onClick={() => this.ValidateCBDet()} tabIndex="5" autofocus />
                                            </td>
                                            <td style={{ display: (this.state.disableNextSaveBtn) ? "none" : "" }}>
                                                <input id='BtnNext' type="button" style={{ textAlign: "center", }} className={this.state.disableNextSaveBtn ? "form1-bu-d" : "formWizard-bu"}
                                                    disabled={this.state.disableNextSaveBtn} value="Next" onClick={() => this.OnNextClick()} tabIndex="6" autofocus />
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div id="dvBranchDtl" className="WizardBranchPanel" >
                        <div style={{ overflowY: "scroll", width: "auto", height: "585px", marginTop: "15px", scrollbarWidth: "thin" }}>
                        <table className="my-special-table" style={{ marginLeft: "auto", marginRight: "auto", borderSpacing: "0px 0.5em" }}>
                            <tr>
                                <th colSpan="2">
                                    <h2 style={{ color: "#25bef6" }}>Update Branch Info</h2>
                                </th>
                                <th colSpan="2">
                                    <h2 style={{ color: "#25bef6" }}>{this.state.CurrLocation}/{this.state.LicBranchListDet.length}</h2>
                                </th>

                            </tr>
                            <tr>
                                <td>
                                    <span className="WizardSpan required">Name</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input id="" ref="txtBranchName" type='text' className='userid1' style={{ width: "360px" }}
                                        placeholder="Enter Branch Name" tabIndex="1" value={this.state.LicBranchName}
                                        onChange={(e) => this.onLicBranchNameChnage(e)} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span className="WizardSpan">Code</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input id="" ref="txtBranchCode" type='text' className='userid1' style={{ width: "360px" }}
                                        placeholder="Enter Branch Alias" tabIndex="2" value={this.state.LicBranchCode}
                                        onChange={(e) => this.onLicBranchCodeChnage(e)} />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span className="WizardSpan required">Address</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <textarea rows="2" cols="35" id="" ref="txtBranchAddreess" className='userid1' style={{ width: "360px" }}
                                        placeholder="Enter Address of Branch" tabIndex="3" value={this.state.LicBranchAddreess}
                                        onChange={(e) => this.onLicBranchAddreessChnage(e)} />
                                </td>

                            </tr>
                            <tr>
                                <td>
                                    <span className="WizardSpan required">Country</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input id="" ref="txtCountry" type='text' className='userid1' style={{ width: "360px" }}
                                        placeholder="India" tabIndex="4" value={this.state.LicBranchCountryName} />


                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span className="WizardSpan required">State</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <SGDropDown
                                        id="ddlBranchState"
                                        options={this.state.StateList}
                                        label="Text"
                                        value="Value"
                                        className="userid1"
                                        style={{}}
                                        selectedValue={this.state.LicBranchStateCode}
                                        onChange={(obj) => this.onBranchStateChange(obj)}
                                        tabIndex="5" />


                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span className="WizardSpan">City</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input id="" ref="txtCity" type='text' className='userid1' style={{ width: "360px" }}
                                        placeholder="Enter City" tabIndex="6" value={this.state.LicBranchCity}
                                        onChange={(e) => this.onBranchCityChange(e)} />


                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span className="WizardSpan">Postal Code</span>
                                </td>

                            </tr>
                            <tr>
                                <td>
                                    <input id="" ref="txtPostalCode" type='text' className='userid1' style={{ width: "360px" }}
                                        placeholder="Enter Postal code" tabIndex="7" value={this.state.LicPostalCode}
                                        onChange={(e) => this.onLicPostalCodeChnage(e)} />
                                </td>
                            </tr>

                            <tr style={{ display: this.state.isCustomBroker ? '' : 'none' }}>
                                <td>

                                    <span className="WizardSpan required">CB Licence No.(CHA No.)</span>
                                </td>

                            </tr>
                            <tr style={{ display: this.state.isCustomBroker ? '' : 'none' }}>
                                <td>
                                    <input id="" ref="txtCBLicNo" type='text' className='userid1' style={{ width: "120px", backgroundColor: "darkgrey" }}
                                        value={this.state.CBPANNo} />
                                    <input id="" ref="txtCBLicNo" type='text' className='userid1' style={{ width: "240px" }}
                                        placeholder="Enter 5 Character Sr No. like CH001" tabIndex="8" value={this.state.LicCBLicNo}
                                        onChange={(e) => this.onLicCBLicNoChnage(e)} maxlength="5" />
                                </td>
                            </tr>
                            <tr style={{ display: (this.state.isCustomBroker ? (this.state.CBLicType == "LEASED" ? '' : 'none') : 'none') }}>
                                <td>
                                    <span className="WizardSpan">CB Address</span>
                                </td>
                            </tr>
                            <tr style={{ display: (this.state.isCustomBroker ? (this.state.CBLicType == "LEASED" ? '' : 'none') : 'none') }}>
                                <td>
                                    <input type="textarea" id="" ref="txtCBAddreess" className='userid1' style={{ width: "360px" }}
                                        placeholder="Enter CB Branch Address" value={this.state.LicCBAddreess}
                                        onChange={(e) => this.onLicCBAddreessChnage(e)} tabIndex="9" />
                                </td>
                            </tr>
                            <tr align="center">
                                <td>
                                    <table>
                                        <tr>
                                            <td style={{ display:(this.state.disableUpdateBranch) ? "none" : "" }}>
                                                <input id='BtnSaveBranch' type="button" style={{}} className={this.state.disableUpdateBranch ? "form1-bu-d" : "formWizard-bu"}
                                                        value="Update" disabled={this.state.disableUpdateBranch} onClick={() => this.ValidateLicBranchDet()} tabIndex="10" autofocus />
                                            </td>
                                            <td style={{ display:(this.state.disableNextBranch && !this.state.disableUpdateBranch) ? "none" : ""}}>
                                                <input id='BtnUpdateBranch' type="button" style={{}} className={this.state.disableNextBranch ? "form1-bu-d" : "formWizard-bu"}
                                                        value="Next Branch" disabled={this.state.disableNextBranch} onClick={() => this.NextBranch()} tabIndex="11" autofocus />
                                                </td>
                                                <td style={{ display: (this.state.disableCloseBranch && !this.state.disableUpdateBranch) ? "none" : "", paddingLeft: "10px" }}>
                                                <input id='BtnSkip' type="button" style={{}} className={this.state.disableCloseBranch ? "form1-bu-d" : "formWizard-bu"}
                                                    value="Finish" disabled={this.state.disableCloseBranch} onClick={() => this.CloseWizard()} tabIndex="12" />
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                        </div>
                    </div>
                </div>
                </div>
        );
    }
}
 